import moment from "moment";
import dayjs from "dayjs";
dayjs.extend(require("dayjs/plugin/utc"));

export const convertUTCDateLocal = (utcDate, format) => {
  if (!format) {
    format = "DD/MM/YYYY, HH:mm:ss";
  }

  // Convert UTC date to local date and time
  const localDate = moment.utc(utcDate).local();

  return localDate.format(format);
};

export const convertUTCDate = (date, format) => {
  if (!format) {
    var d = new Date();
    date = new Date(
      dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
    );
  }
  format = format || "MM/DD/YYYY";
  return dayjs(date).utc().format(format);
};

export const convertToUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs(date).utc().format(format);
};

export const convertFromUTCDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (!date) return null;
  return dayjs.utc(date).local().format(format);
};

export const ConvertTime = (time) => {
  const timePart = time.format("HH:mm");
  return `${timePart}`;
};

export const convertDate = (date) => {
  const datePart = dayjs(date, "MM-DD-YYYY").format("MM/DD/YYYY");
  const time = `${datePart}`;
  return time;
};

export const filterValidValues = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ""
    )
  );
};

export const filterCurrentMonthVitals = (dataArray) => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-indexed: Jan = 0
  const currentYear = now.getFullYear();

  return dataArray.filter(item => {
    const itemDate = new Date(item.recordedDateTime);
    return (
      itemDate.getMonth() === currentMonth &&
      itemDate.getFullYear() === currentYear
    );
  });
}
export const calculateAge = (dob) => {
  const dobData = dob;
  const dobYear = dobData?.split("/")[2];
  const currYear = new Date().getFullYear();
  if (dobYear) {
    const patientAge = currYear - Number(dobYear);
    return patientAge;
  }
};